export const STAGES = [
  { id: "new_lead", label: "New Lead", color: "#6366F1", badgeBg: "rgba(99,102,241,0.15)", badgeText: "#A5B4FC" },
  { id: "follow_up_book", label: "Follow-up · Book Call", color: "#F59E0B", badgeBg: "rgba(245,158,11,0.15)", badgeText: "#FCD34D" },
  { id: "call_scheduled", label: "Call Scheduled", color: "#06B6D4", badgeBg: "rgba(6,182,212,0.15)", badgeText: "#67E8F9" },
  { id: "follow_up_close", label: "Follow-up · Close", color: "#8B5CF6", badgeBg: "rgba(139,92,246,0.15)", badgeText: "#C4B5FD" },
  { id: "closed_lost", label: "Closed Lost", color: "#EF4444", badgeBg: "rgba(239,68,68,0.15)", badgeText: "#FCA5A5" },
  { id: "closed_won", label: "Closed Won", color: "#10B981", badgeBg: "rgba(16,185,129,0.15)", badgeText: "#6EE7B7" },
];

export const STAGE_MAP = Object.fromEntries(STAGES.map((s) => [s.id, s]));

export const TAG_STYLES = {
  Contacted: { bg: "rgba(99,102,241,0.15)", text: "#A5B4FC" },
  "Had Call": { bg: "rgba(16,185,129,0.15)", text: "#6EE7B7" },
  "No-show": { bg: "rgba(239,68,68,0.15)", text: "#FCA5A5" },
  "Proposal Sent": { bg: "rgba(245,158,11,0.15)", text: "#FCD34D" },
  "Decision Maker": { bg: "rgba(6,182,212,0.15)", text: "#67E8F9" },
};

export const SOURCES = ["Manual", "Typeform", "Referral", "Inbound", "Cold"];
export const ALL_TAGS = ["Contacted", "Had Call", "No-show", "Proposal Sent", "Decision Maker"];

export const fmtMoney = (n) =>
  "$" + Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
